<template>
  <v-expansion-panels>
    <template v-for="(question, index) in questions">
      <Question
        v-if="(question[`question_${$i18n.locale}`] != '' && question[`question_${$i18n.locale}`])"
        :key="`question-${index}`"
        :question="question[`question_${$i18n.locale}`]"
        :answer="question[`answer_${$i18n.locale}`]"
      >
      </Question>
      <Question
        v-else-if="question.question || question.answer"
        :key="`answer-${index}`"
        :question="question.question"
        :answer="question.answer"
      ></Question>
    </template>
  </v-expansion-panels>
</template>

<script>
import Question from './Question'

export default {
  props: {
    questions: Array | Object
  },

  components: {
    Question: Question
  }
}
</script>
